import { styled } from '@mui/material/styles';

export const StyledSelect = styled('select')`
  background: url("data:image/svg+xml,<svg height='16px' width='16px' viewBox='0 0 16 16' fill='%23000000' xmlns='http://www.w3.org/2000/svg'><path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>")
    no-repeat;
  background-position: calc(100% - 0.75rem) center !important;
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  padding-left: 0.75rem !important;
  padding-right: 2rem !important;

  border: 1px solid rgb(0, 0, 0, 0.2);
  border-radius: 5px;
  height: 55px;
  width: 100%;
  :focus {
    border: 2px solid #3f51b5;
  }
  :hover {
    border: 1px solid black;
  }
`;
